import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "ئاگاداریی کوکی",
    description:
      "ئێمە کوکییە پێویستەکان بەکاردەهێنین بۆ دڵنیابوون لەوەی ئەم وێبسایتە بە دروستی کاردەکات. هەروەها کوکییەکانی بەدواداچون بە ئیختیاری بەکاردەهێنین بۆ یارمەتیدان لێمان بۆ تێگەیشتن لەوەی چۆن لەگەڵ وێبسایتەکە دەکەویتەوە. ئەم کوکییە ئیختیارییانە تەنها بە ڕەزامەندیی تۆ دەچێتە کار.",
    acceptAllBtn: "هەمووی پەسەند بکە",
    acceptNecessaryBtn: "هەمووی ڕەت بکە",
    showPreferencesBtn: "هەڵبژاردە تایبەتییەکان بەڕێوەبەرە",
  },
  preferencesModal: {
    title: "بەڕێوەبردنی هەڵبژاردەی کوکی",
    acceptAllBtn: "هەمووی پەسەند بکە",
    acceptNecessaryBtn: "هەمووی ڕەت بکە",
    savePreferencesBtn: "هەڵبژاردەی ئێستا پەسەند بکە",
    closeIconLabel: "پەنجەرە دابخە",
    sections: [
      {
        title: "بەکارهێنانی کوکی",
        description:
          "ئێمە کوکی بەکاردەهێنین بۆ پشتگری لە ئەرکە بنەڕەتییەکانی ئەم وێبسایتە و بۆ باشترکردنی ئەزموونی گەڕانەکەت.",
      },
      {
        title: "کوکییە پێویستەکان بە تەواوی",
        description:
          "ئەم کوکییانە بۆ کارکردنی دروست وێبسایتەکە پێویستن، وەک نمونە بۆ ناسێنەری بەکارهێنەر.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "ناو",
            domain: "خزمەتگوزاری",
            description: "داڕشتن",
            expiration: "کاتی بەسەرچوون",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description:
                "کوکی لەلایەن پلاتفۆڕمی کۆمەڵگای دیجیتاڵ سەڵاتدەدرێت بۆ ناسێنەری بەکارهێنەر.",
              expiration: "دانیشتن",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description:
                "کوکی لەلایەن پلاتفۆڕمی کۆمەڵگای دیجیتاڵ سەڵات دەدرێت بۆ ناسێنەری بەکارهێنەر",
              expiration: "دانیشتن",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "ئەم کوکییە بۆ جیاکردنەوەی مرۆڤ و بۆت بەکاردێت بۆ پاراستنی وێبسایت لە خراپکاریی ئۆتۆماتیکی. هیچ زانیارییەکی کەسی کۆڵنەکراوەتەوە.",
              expiration: "30 خولەک",
            },
          ],
        },
      },
      {
        title: "شیکاری",
        description:
          "کوکییەکانی شیکاری یارمەتیدان بە کۆکردنەوەی داتا دەکەن، کە رێگە بە خزمەتگوزارییەکان دەدات بە تێگەیشتن لە چۆنیەتی کاریگەری بەکارهێنەران لەگەڵ خزمەتگوزارییەکی تایبەتی. ئەم تێگەیشتنە یارمەتیدان دەکەن بۆ باشترکردنی ناوەڕۆک و دروستکردنی تایبەتمەندییە باشترەکان کە ئەزموونی بەکارهێنەر باشتر دەکەن.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "ناو",
            domain: "خزمەتگوزاری",
            description: "داڕشتن",
            expiration: "کاتی بەسەرچوون",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'کوکی لەلایەن <a href="https://business.safety.google/adscookies/">Google Analytics</a> دانراوە',
              expiration: "لە 12 ڕۆژ دوایدا بەسەردەچێت",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'کوکی لەلایەن <a href="https://business.safety.google/adscookies/">Google Analytics</a> دانراوە',
              expiration: "دانیشتن",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel =
  "خزنه‌کردنی پەیوەندیدار بە شیکاری چالاکدەکات، بۆ نمونە ماوەی سەردان.";

export { translation, servicesLabel };
